import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

function RoundPinchIcon(props) {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill="currentColor"
        d="M8.2 17.43c0-.65.6-1.13 1.24-.99l3.56.8V6.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v6h.91c.31 0 .62.07.89.21l4.09 2.04c.77.38 1.21 1.22 1.09 2.07l-.63 4.46c-.14.99-.99 1.72-1.98 1.72h-6.16c-.53 0-1.29-.21-1.66-.59l-4.07-4.29a.976.976 0 0 1-.28-.69zM9.5 5.25c0 .41.34.75.75.75s.75-.34.75-.75V2c0-.55-.45-1-1-1H6.75c-.41 0-.75.34-.75.75s.34.75.75.75h1.69L2.5 8.44V6.75c0-.41-.34-.75-.75-.75S1 6.34 1 6.75V10c0 .55.45 1 1 1h3.25c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H3.56L9.5 3.56v1.69z"
      />
    </SvgIcon>
  );
}

export default RoundPinchIcon;
